import { Link, type LinkProps } from "react-router-dom";
import { useDates } from "dates/DatesContext";
import { generateUrl } from "dates/utils";

interface Props extends LinkProps {
  to: string;
}

const TrellisLink = ({ to, children, ...rest }: Props) => {
  const dates = useDates();
  const url = generateUrl(to, dates);

  return (
    <Link to={url} {...rest}>
      {children}
    </Link>
  );
};

export default TrellisLink;
